import React from "react";
import Menu from "antd/lib/menu";
import PageHeader from "@/components/page-header";
import Link from "@/components/Link";
import location from "@/services/location";
import settingsMenu from "@/services/settingsMenu";
import { useTheme } from "@/components/ThemeProvider";

import "./SettingsWrapper.less";

function wrapSettingsTab(id, options, WrappedComponent) {
  settingsMenu.add(id, options);

  return function SettingsTab(props) {
    const activeItem = settingsMenu.getActiveItem(location.path);
    const { isDarkMode } = useTheme();

    return (
      <div className={`settings-screen ${isDarkMode ? 'dark-mode' : ''}`}>
        <div className="container">
          <PageHeader title="Settings" />
          <div className={`bg-white tiled ${isDarkMode ? 'dark-mode' : ''}`}>
            <Menu selectedKeys={[activeItem && activeItem.title]} selectable={false} mode="horizontal" className={isDarkMode ? 'dark-mode' : ''}>
              {settingsMenu.getAvailableItems().map(item => (
                <Menu.Item key={item.title}>
                  <Link href={item.path} data-test="SettingsScreenItem">
                    {item.title}
                  </Link>
                </Menu.Item>
              ))}
            </Menu>
            <div className="p-15">
              <div>
                <WrappedComponent {...props} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
}

export default wrapSettingsTab;
